
export default {
  init() {
    // JavaScript to be fired on the home page
/*
    const fade_slider = $('[data-fade-slider]');
    fade_slider.slick({
      dots: true,
      arrows: false,
      infinite: true,
      speed: 3000,
      fade: true,
      cssEase: 'linear',
    });
*/
    let counterFlag = true;
    window.onscroll = function (e) {
      if(counterFlag && isScrolledIntoView(document.querySelector('[data-main-saved]'))) {
        counter(25, '[data-mainpage-counter-1]', parseInt($('[data-mainpage-counter-1]').text()));
        counter(25, '[data-mainpage-counter-2]', parseInt($('[data-mainpage-counter-2]').text()));
        counter(25, '[data-mainpage-counter-3]', parseInt($('[data-mainpage-counter-3]').text()));
        counter(25, '[data-mainpage-counter-4]', parseInt($('[data-mainpage-counter-4]').text()));
        counterFlag = false;
      }

      let scroll_top = $('body, html').scrollTop();
      let vertical_slider_offset = $('.main-vertical-slider').offset().top;
      if(scroll_top > vertical_slider_offset) {
        e.preventDefault();
      }
    };

    function counter(ms, dataParam, endPoint){
      let counter = 0;
      let interval = setInterval(() => {
        document.querySelector(dataParam).innerHTML = ++counter;
        counter === endPoint ? clearInterval(interval) : false;
      }, ms)
    }

    function isScrolledIntoView(el, view_type = 'full') {
      let rect = el.getBoundingClientRect();
      let elemTop = rect.top;
      let elemBottom = rect.bottom;
      let isVisible;
  
      if(view_type === 'full') {
        // Only completely visible elements return true:
        isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
      } else {
        // Partially visible elements return true:
        isVisible = elemTop < window.innerHeight && elemBottom >= 0;
      }

      return isVisible;
    }
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};




// WEBPACK FOOTER //
// ./scripts/routes/home.js